import myAxios from './myAxios';

export async function getNotifications() {
  return myAxios.get('/notification/');
}

export async function getStickyNotification() {
  return myAxios.get('/notification/sticky/');
}
